export enum Space {
  S2 = 'S2',
  S4 = 'S4',
  S8 = 'S8',
  S12 = 'S12',
  S16 = 'S16',
  S20 = 'S20',
  S24 = 'S24',
  S32 = 'S32',
  S40 = 'S40',
  S48 = 'S48',
  S56 = 'S56',
  S64 = 'S64',
  S88 = 'S88',
}

export interface SpaceProps {
  S2: string
  S4: string
  S8: string
  S12: string
  S16: string
  S20: string
  S24: string
  S32: string
  S40: string
  S48: string
  S56: string
  S64: string
  S88: string
}

export const space: SpaceProps = {
  S2: '2px',
  S4: '4px',
  S8: '8px',
  S12: '12px',
  S16: '16px',
  S20: '20px',
  S24: '24px',
  S32: '32px',
  S40: '40px',
  S48: '48px',
  S56: '56px',
  S64: '64px',
  S88: '88px',
}
